import { render, staticRenderFns } from "./T6.vue?vue&type=template&id=4e87f890&"
import script from "./T6.vue?vue&type=script&lang=js&"
export * from "./T6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports